var _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgEventTypeNotification01 = function SvgEventTypeNotification01(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 200 200",
    focusable: false,
    "aria-hidden": true
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "event_type_notification-01_svg2__a",
    x1: 62.93,
    x2: 188.67,
    y1: 203.15,
    y2: 59.9,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#3d43c1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#a80096"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#event_type_notification-01_svg2__a",
    id: "event_type_notification-01_svg2__b",
    x1: -24,
    x2: 101.74,
    y1: 126.84,
    y2: -16.41
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#event_type_notification-01_svg2__a",
    id: "event_type_notification-01_svg2__c",
    x1: 19.47,
    x2: 145.21,
    y1: 164.99,
    y2: 21.75
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#event_type_notification-01_svg2__a",
    id: "event_type_notification-01_svg2__d",
    x1: 46.25,
    x2: 171.99,
    y1: 188.5,
    y2: 45.25
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#event_type_notification-01_svg2__a",
    id: "event_type_notification-01_svg2__e",
    x1: 47.4,
    x2: 173.14,
    y1: 189.51,
    y2: 46.26
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#event_type_notification-01_svg2__a",
    id: "event_type_notification-01_svg2__f",
    x1: 47.83,
    x2: 173.57,
    y1: 189.89,
    y2: 46.64
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#event_type_notification-01_svg2__a",
    id: "event_type_notification-01_svg2__g",
    x1: 20,
    x2: 145.74,
    y1: 165.46,
    y2: 22.21
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#event_type_notification-01_svg2__a",
    id: "event_type_notification-01_svg2__h",
    x1: 12.19,
    x2: 137.93,
    y1: 158.6,
    y2: 15.36
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M70.25 190.61h12.52c1.62 0 2.94-1.31 2.94-2.94s-1.32-2.94-2.94-2.94H70.25c-1.62 0-2.94 1.32-2.94 2.94s1.31 2.94 2.94 2.94",
    style: {
      fill: "url(#event_type_notification-01_svg2__a)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79.65 9.39h-6.26c-1.62 0-2.94 1.31-2.94 2.94s1.31 2.94 2.94 2.94h6.26c1.62 0 2.94-1.32 2.94-2.94s-1.32-2.94-2.94-2.94",
    style: {
      fill: "url(#event_type_notification-01_svg2__b)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M167.32 43.84h-37.77V9.2c0-5.07-4.13-9.2-9.2-9.2H32.68c-5.07 0-9.2 4.13-9.2 9.2v181.6c0 5.07 4.13 9.2 9.2 9.2h87.67c5.07 0 9.2-4.13 9.2-9.2v-53.42h37.77c5.07 0 9.2-4.13 9.2-9.2V53.03c0-5.07-4.13-9.2-9.2-9.2ZM29.35 9.2c0-1.83 1.49-3.33 3.33-3.33h87.67c1.83 0 3.33 1.49 3.33 3.33v9.59H29.35zm94.33 181.6c0 1.83-1.49 3.33-3.33 3.33H32.68c-1.83 0-3.33-1.49-3.33-3.33v-9.59h94.32v9.59Zm46.97-62.62c0 1.83-1.49 3.33-3.33 3.33H92.17c-.63 0-1.25.21-1.76.59l-20.35 15.26V76.52c0-1.62-1.32-2.94-2.94-2.94s-2.94 1.32-2.94 2.94v76.71c0 2.37 2.8 3.78 4.7 2.35l24.27-18.2h30.53v37.96H29.35V24.66h94.32v19.18H73.38c-5.07 0-9.2 4.13-9.2 9.2v9.39c0 1.62 1.31 2.94 2.94 2.94s2.94-1.32 2.94-2.94v-9.39c0-1.83 1.49-3.33 3.33-3.33h93.93c1.83 0 3.33 1.49 3.33 3.33v75.15Z",
    style: {
      fill: "url(#event_type_notification-01_svg2__c)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M145.4 109.59h-2.92c-.4-.16-3.53-1.77-3.53-12.72 0-21.62-11.65-24.85-18.59-24.85s-18.59 3.23-18.59 24.85c0 10.95-3.13 12.56-3.53 12.72h-2.92c-1.62 0-2.94 1.32-2.94 2.94s1.32 2.94 2.94 2.94h15.86v.2c0 5.07 4.13 9.2 9.2 9.2s9.2-4.13 9.2-9.2v-.2h15.86c1.62 0 2.94-1.32 2.94-2.94s-1.32-2.94-2.94-2.94Zm-25.05 9.39c-1.83 0-3.33-1.49-3.33-3.33 0-.07 0-.13.01-.2h6.63c0 .07.01.13.01.2 0 1.83-1.49 3.33-3.33 3.33Zm-14.83-9.39c1.23-2.75 2.12-6.79 2.12-12.72 0-18.98 9.57-18.98 12.72-18.98s12.72 0 12.72 18.98c0 5.93.89 9.97 2.12 12.72h-29.67Z",
    style: {
      fill: "url(#event_type_notification-01_svg2__d)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M139.14 72.02c-1.62 0-2.94 1.32-2.94 2.94s1.32 2.94 2.94 2.94c3.56 0 6.46 2.9 6.46 6.46 0 1.62 1.32 2.94 2.94 2.94s2.94-1.32 2.94-2.94c0-6.8-5.53-12.33-12.33-12.33Z",
    style: {
      fill: "url(#event_type_notification-01_svg2__e)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M139.14 59.49c-1.62 0-2.94 1.31-2.94 2.94s1.32 2.94 2.94 2.94c10.47 0 18.98 8.51 18.98 18.98 0 1.62 1.32 2.94 2.94 2.94s2.94-1.32 2.94-2.94c0-13.7-11.15-24.85-24.85-24.85Z",
    style: {
      fill: "url(#event_type_notification-01_svg2__f)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M95.11 84.34c0-3.56 2.9-6.46 6.46-6.46 1.62 0 2.94-1.32 2.94-2.94S103.19 72 101.57 72c-6.8 0-12.33 5.53-12.33 12.33 0 1.62 1.31 2.94 2.94 2.94s2.94-1.32 2.94-2.94Z",
    style: {
      fill: "url(#event_type_notification-01_svg2__g)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M104.5 62.43c0-1.62-1.32-2.94-2.94-2.94-13.7 0-24.85 11.15-24.85 24.85 0 1.62 1.31 2.94 2.94 2.94s2.94-1.32 2.94-2.94c0-10.47 8.51-18.98 18.98-18.98 1.62 0 2.94-1.32 2.94-2.94Z",
    style: {
      fill: "url(#event_type_notification-01_svg2__h)"
    }
  }));
};
export default SvgEventTypeNotification01;